export const mockDepartment = [
  {
    id: 7,
    name: 'Legal',
  },
];
